







import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'EmptyPlaceholder',
})
export default class EmptyPlaceholder extends Vue {}
